import { useEffect, useMemo, useRef } from "react";
import { createLongPress } from "@/lib/long-press";

/** Pointer handlers for a long-press on touch/pen only; mouse keeps its normal clicks. */
export function useLongPress(onLongPress: () => void) {
  const cb = useRef(onLongPress);
  cb.current = onLongPress;
  const touch = useRef(false);
  const lp = useMemo(() => createLongPress(() => cb.current()), []);
  useEffect(() => {
    window.addEventListener("scroll", lp.cancel, { passive: true, capture: true });
    return () => {
      window.removeEventListener("scroll", lp.cancel, { capture: true });
      lp.cancel();
    };
  }, [lp]);
  return {
    onPointerDown: (e: React.PointerEvent) => {
      touch.current = e.pointerType !== "mouse";
      if (touch.current) lp.down(e);
    },
    onPointerMove: (e: React.PointerEvent) => lp.move(e),
    onPointerUp: lp.cancel,
    onPointerCancel: lp.cancel,
    // The system long-press menu would cover the save action on phones.
    onContextMenu: (e: React.MouseEvent) => { if (touch.current) e.preventDefault(); },
    onClickCapture: (e: React.MouseEvent) => {
      if (lp.consumeClick()) { e.preventDefault(); e.stopPropagation(); }
    },
  };
}
